import {
  TableCell,
  TableHead as TableHeadDS,
  TableRow,
} from '@cambridgeassessment/cambridge-ui';
import * as React from 'react';
import { memo, useCallback } from 'react';
import { TooltipContent } from 'src/types';
import TableHeadLabel from './TableHeadLabel';
import TableHeadLabelSort from './TableHeadLabelSort';
import { HeadCell, Order } from './types';

type Props = {
  headCells: HeadCell[];
  order: Order;
  orderBy: string;
  onRequestSort: (
    event: React.MouseEvent<HTMLButtonElement>,
    property: string
  ) => void;
  tooltips?: TooltipContent;
};

const TableHead: React.FC<Props> = ({
  headCells,
  order,
  orderBy,
  onRequestSort,
  tooltips,
}) => {
  const createSortHandler = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>, property: string) => {
      onRequestSort(event, property);
    },
    [onRequestSort]
  );

  return (
    <TableHeadDS>
      <TableRow>
        {headCells.map(({ id, label, order: defaultOrder }) => (
          <TableCell key={id} align="left" padding="normal">
            {defaultOrder === Order.NA ? (
              <TableHeadLabel
                description={tooltips && tooltips[label]}
                label={label}
              />
            ) : (
              <TableHeadLabelSort
                key={id}
                active={orderBy === id}
                description={tooltips && tooltips[label.toLowerCase()]}
                label={label}
                onClick={(event) => {
                  createSortHandler(event, id);
                }}
                order={order}
              />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHeadDS>
  );
};

export default memo(TableHead);
